import { useEffect, useRef, useState } from 'react'
import './siteShell.css'

const logoUrl = 'https://www.160drivingacademy.com/wp-content/uploads/2026/08/logo.svg'

const navigationLinks = [
  {
    label: 'School Locations',
    href: 'https://www.160drivingacademy.com/locator/',
    children: []
  },
  {
    label: 'Our School',
    href: 'https://www.160drivingacademy.com/truck-driving-classes/',
    children: [
      { label: 'Programs', href: 'https://www.160drivingacademy.com/programs/' },
      {
        label: 'CDL Class A',
        href: 'https://www.160drivingacademy.com/truck-driving-classes/class-a/'
      },
      {
        label: 'CDL Refresher Course',
        href: 'https://www.160drivingacademy.com/truck-driving-classes/cdl-refresher/'
      },
      {
        label: 'ELDT Courses',
        href: 'https://www.160drivingacademy.com/truck-driving-classes/eldt/'
      },
      {
        label: 'Hazmat Certification',
        href: 'https://www.160drivingacademy.com/truck-driving-classes/hazmat-certification/'
      },
      {
        label: '160 Student App',
        href: 'https://www.160drivingacademy.com/truck-driving-classes/160-app/'
      }
    ]
  },
  {
    label: 'Benefits',
    href: 'https://www.160drivingacademy.com/truck-driving-school-benefits/',
    children: [
      {
        label: 'Job Placement',
        href: 'https://www.160drivingacademy.com/truck-driving-school-benefits/job-placement/'
      }
    ]
  },
  {
    label: 'Find Jobs',
    href: 'https://www.160drivingacademy.com/truck-driving-careers/',
    children: [
      {
        label: 'How to Get a CDL',
        href: 'https://www.160drivingacademy.com/truck-driving-careers/get-a-cdl/'
      },
      {
        label: 'CDL Jobs',
        href: 'https://www.160drivingacademy.com/truck-driving-careers/cdl-jobs/'
      },
      {
        label: 'Truck Driving Jobs',
        href: 'https://www.160drivingacademy.com/truck-driving-careers/trucking-jobs/'
      },
      {
        label: 'CDL Test',
        href: 'https://www.160drivingacademy.com/truck-driving-classes/cdl-test/'
      }
    ]
  },
  {
    label: 'Endorsements',
    href: 'https://www.160drivingacademy.com/endorsements/',
    children: []
  },
  {
    label: 'Payment Plans',
    href: 'https://www.160drivingacademy.com/flexible-ways-to-pay/',
    children: [
      {
        label: 'Pay Monthly With Affirm',
        href: 'https://www.160drivingacademy.com/flexible-ways-to-pay/affirm-finance/'
      },
      {
        label: 'WIOA Funding',
        href: 'https://www.160drivingacademy.com/flexible-ways-to-pay/wioa-funding/'
      }
    ]
  },
  {
    label: 'Industry Partnerships',
    href: 'https://www.160drivingacademy.com/training-partnerships/',
    children: [
      {
        label: 'CDL Training Partnerships',
        href: 'https://www.160drivingacademy.com/cdl-training-partnerships/'
      },
      {
        label: '160 Next Hire',
        href: 'https://www.160drivingacademy.com/160-next-hire/'
      },
      {
        label: '160 Driver Score',
        href: 'https://www.160drivingacademy.com/160-driver-score/'
      },
      {
        label: 'Onsite Recruitment',
        href: 'https://www.160drivingacademy.com/onsite-recruitment/'
      }
    ]
  }
] as const

const actionLinks = [
  {
    label: 'Hire Now',
    href: 'https://www.160drivingacademy.com/cdl-training-partnerships/',
    icon: HireIcon
  },
  {
    label: 'Join the 160 Team',
    href: 'https://www.160drivingacademy.com/careers/',
    icon: CareerIcon
  }
] as const

function Chevron() {
  return (
    <svg aria-hidden="true" viewBox="0 0 12 8">
      <path d="M6 8 0 1.41 1.41 0 6 4.59 10.59 0 12 1.41 6 8Z" fill="currentColor" />
    </svg>
  )
}
function HireIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 18 18">
      <path
        d="M0 18V4h4V0h10v8h4v10h-8v-4H8v4H0Zm2-2h2v-2H2v2Zm0-4h2v-2H2v2Zm0-4h2V6H2v2Zm4 4h2v-2H6v2Zm0-4h2V6H6v2Zm0-4h2V2H6v2Zm4 8h2v-2h-2v2Zm0-4h2V6h-2v2Zm0-4h2V2h-2v2Zm4 12h2v-2h-2v2Zm0-4h2v-2h-2v2Z"
        fill="currentColor"
      />
    </svg>
  )
}
function CareerIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 22 18">
      <path
        d="M11 18 4 14.2v-6L0 6l11-6 11 6v8h-2V7.1l-2 1.1v6L11 18Zm0-8.3L17.85 6 11 2.3 4.15 6 11 9.7Zm0 6.025 5-2.7V9.25L11 12 6 9.25v3.775l5 2.7Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function SiteHeader() {
  const [open, setOpen] = useState(false)
  const [stuck, setStuck] = useState(false)
  const menuButton = useRef<HTMLButtonElement>(null)
  const menuPanel = useRef<HTMLElement>(null)

  useEffect(() => {
    const updateStuck = () => setStuck((current) => current ? window.scrollY > 0 : window.scrollY > 44)

    updateStuck()
    window.addEventListener('scroll', updateStuck, { passive: true })

    return () => window.removeEventListener('scroll', updateStuck)
  }, [])

  useEffect(() => {
    if (!open) {
      return
    }

    const previousOverflow = document.body.style.overflow

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setOpen(false)
        return
      }

      if (event.key !== 'Tab') {
        return
      }

      const controls = menuPanel.current?.querySelectorAll<HTMLElement>(
        'a[href], button:not([disabled]), summary'
      )

      if (!controls?.length) {
        return
      }

      const first = controls[0]
      const last = controls[controls.length - 1]

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    }

    document.body.style.overflow = 'hidden'
    menuPanel.current?.querySelector<HTMLElement>('button')?.focus()
    window.addEventListener('keydown', handleKeyDown)

    return () => {
      document.body.style.overflow = previousOverflow
      window.removeEventListener('keydown', handleKeyDown)
      menuButton.current?.focus()
    }
  }, [open])

  return (
    <header className={`academy-site-header${stuck ? ' is-stuck' : ''}`}>
      <a className="academy-skip-link" href="#main-content">
        Skip to main content
      </a>

      <div className="academy-site-header__main">
        <a
          className="academy-site-header__logo"
          href="https://www.160drivingacademy.com/"
          aria-label="160 Driving Academy home"
        >
          <img src={logoUrl} alt="160 Driving Academy" width="175" height="60" />
        </a>

        <nav
          className="academy-site-nav academy-site-nav--desktop"
          aria-label="Primary navigation"
        >
          <ul>
            {navigationLinks.map(link => (
              <li
                className={
                  link.children.length > 0
                    ? 'academy-site-nav__item academy-site-nav__item--dropdown'
                    : 'academy-site-nav__item'
                }
                key={link.label}
              >
                <a href={link.href}>{link.label}</a>
                {link.children.length > 0 && (
                  <>
                    <span className="academy-site-nav__chevron">
                      <Chevron />
                    </span>
                    <ul className="academy-site-nav__submenu">
                      {link.children.map(child => (
                        <li key={child.label}>
                          <a href={child.href}>{child.label}</a>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <div className="academy-site-header__actions">
          {actionLinks.map(action => {
            const Icon = action.icon

            return (
              <a href={action.href} key={action.label}>
                <Icon />
                <span>{action.label}</span>
              </a>
            )
          })}
        </div>

        <div
          className={
            open
              ? 'academy-site-nav--mobile is-open'
              : 'academy-site-nav--mobile'
          }
        >
          <button
            ref={menuButton}
            className="academy-site-nav__toggle"
            type="button"
            aria-expanded={open}
            aria-controls="academy-mobile-navigation"
            onClick={() => setOpen(true)}
          >
            <span className="academy-site-nav__lines" aria-hidden="true" />
            <span className="academy-sr-only">Open menu</span>
          </button>

          <button
            className="academy-site-nav__backdrop"
            type="button"
            aria-label="Close menu"
            tabIndex={open ? 0 : -1}
            onClick={() => setOpen(false)}
          />

          <nav
            ref={menuPanel}
            className="academy-site-nav__panel"
            id="academy-mobile-navigation"
            aria-label="Mobile navigation"
            aria-hidden={!open}
          >
            <div className="academy-site-nav__panel-head">
              <img src={logoUrl} alt="160 Driving Academy" width="140" height="47" />
              <button type="button" aria-label="Close menu" onClick={() => setOpen(false)}>
                ×
              </button>
            </div>

            <ul>
              {navigationLinks.map(link => (
                <li key={link.label}>
                  {link.children.length > 0 ? (
                    <details>
                      <summary>
                        {link.label}
                        <Chevron />
                      </summary>
                      <ul>
                        <li>
                          <a href={link.href}>Overview</a>
                        </li>
                        {link.children.map(child => (
                          <li key={child.label}>
                            <a href={child.href}>{child.label}</a>
                          </li>
                        ))}
                      </ul>
                    </details>
                  ) : (
                    <a href={link.href}>{link.label}</a>
                  )}
                </li>
              ))}
            </ul>

            <div className="academy-site-nav__panel-actions">
              {actionLinks.map(action => (
                <a href={action.href} key={action.label}>
                  {action.label}
                </a>
              ))}
            </div>
          </nav>
        </div>
      </div>
    </header>
  )
}
